import React, { useEffect, useState } from 'react';

function ChatScreen() {
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => {
    setLoading(false); // Set loading to false when iframe is loaded
  };
  // useEffect(() => {
  //   const script = document.createElement('script');
  //   script.type = 'text/javascript';
  //   script.src = 'https://flowbridge-chat-assets.s3.eu-west-3.amazonaws.com/bundle/flowbridge-chat-v1.mjs';

  //   script.onload = () => {
  //     // Wait until the chat object is available
  //     if (window.voiceflow && window.voiceflow.chat) {
  //       window.voiceflow.chat.load({
  //           verify: { projectID: '6644b1bfe62f5d516c48f1e3' },
  //           url: 'https://payvessel.flowbridge.app/api/webchat/2/',
  //           assistant: {
  //               stylesheet: 'https://payvessel.flowbridge.app/api/webchat/2/css',
  //               persistence: 'localStorage'
  //           },
  //           versionID: 'production'
  //       })
  //         .then(() => {
  //           setLoading(false);
  //           // Open chat after 1 second
  //           setTimeout(() => {
  //             if (window.voiceflow && window.voiceflow.chat) {
  //               window.voiceflow.chat.open();
  //             }
  //           }, 1000);
  //         })
  //         .catch((error) => {
  //           console.error('Voiceflow chat failed to load:', error);
  //           setLoading(false);
  //         });
  //     } else {
  //       console.error('Voiceflow chat is not available');
  //       setLoading(false);
  //     }
  //   };

  //   document.body.appendChild(script);

  //   // Cleanup script on component unmount
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  return (
    <div className="ChatScreen" style={{ position: 'relative', height: '100vh', backgroundColor: 'black' }}>
     {loading && (
        <div 
        style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'black',
                  color: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 9999,
                }}
          >
         <h1 >Loading ChatBot...</h1>
        </div>
      )}
      <iframe
        src="https://creator.voiceflow.com/prototype/6644b1bfe62f5d516c48f1e4"
        width="100%"
        height="90%"
        style={{ border: "none" }}
        title="Payvessel Ai"
        onLoad={handleIframeLoad} 
      />
    </div>
    // <div className="ChatScreen" style={{ position: 'relative', minHeight: '100vh', backgroundColor: 'black' }}>
    //   {loading ? (
    //     <div
    //       style={{
    //         position: 'absolute',
    //         top: 0,
    //         left: 0,
    //         right: 0,
    //         bottom: 0,
    //         backgroundColor: 'black',
    //         color: 'white',
    //         display: 'flex',
    //         justifyContent: 'center',
    //         alignItems: 'center',
    //         zIndex: 9999,
    //       }}
    //     >
    //       <h1>Loading ChatBot...</h1>
    //     </div>
    //   ) : null}
    // </div>
  );
}

export default ChatScreen;
